module.exports = {
    // REVISION COMPOUNENT
    endpoint_get_revision : `${process.env.REACT_APP_API_URL}/api/quizzes/v1/details/`,
    endpoint_post_answer_revision: `${process.env.REACT_APP_API_URL}/api/questions/v1/answer`,
    endpoint_post_answer_revision_ccqcm : `${process.env.REACT_APP_API_URL}/api/questions/v1/answer-ccqcm`,
    endpoint_post_flag_question : `${process.env.REACT_APP_API_URL}/api/questions/v1/flag`,
    endpoint_get_user_playlists : `${process.env.REACT_APP_API_URL}/api/playlists/v1/all`,
    endpoint_post_add_question_to_playlist : `${process.env.REACT_APP_API_URL}/api/questions/v1/add-to-playlist`,
    endpoint_post_create_playlist  : `${process.env.REACT_APP_API_URL}/api/playlists/v1/store`,
    endpoint_post_add_comment : `${process.env.REACT_APP_API_URL}/api/questions/v1/note`,
    endpoint_get_comment : `${process.env.REACT_APP_API_URL}/api/questions/v1/note/`,
    // MULTI SELECT COMPOUNENT
    endpoint_get_tags : `${process.env.REACT_APP_API_URL}/api/quizzes/v1/tags`,
    endpoint_post_build_quiz : `${process.env.REACT_APP_API_URL}/api/quizzes/v1/create`,
    endpoint_get_all_modules: `${process.env.REACT_APP_API_URL}/api/quizzes/v1/subjects`,
    // LOGIN/REGISTER PAGE
    endpoint_post_login_user : `${process.env.REACT_APP_API_URL}/api/users/v1/login`

}
